module.exports = __webpack_public_path__ + "5a8334bb7400d5ea303fb631d71c7dac.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-32.png
// module id = 1648
// module chunks = 0